import { render, staticRenderFns } from "./TagColorDisplay.vue?vue&type=template&id=42d27d2d&"
import script from "./TagColorDisplay.vue?vue&type=script&lang=ts&"
export * from "./TagColorDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports